import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimeZoneService {

  constructor(private dataService: DataService) { }

  getTimeZones(): Observable<any> {
    return this.dataService.getTimeZones();
  }
}
